module.exports = __webpack_public_path__ + "static/img/12.110f831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12.png
// module id = FUCY
// module chunks = 7